import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchGetBackups, fetchRunBackup, fetchRestoreBackup } from "./actions";
import {IBackupItem} from "../../../models/IBackup";

interface IBackupState {
    list: IBackupItem[];
    isLoading: boolean;
    isRestoring: boolean;
}

const initialState: IBackupState = { list: [], isLoading: false, isRestoring: false };

export const BackupSlice = createSlice({
    name: "backup_slice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchGetBackups.pending, (s) => { s.isLoading = true; })
            .addCase(fetchGetBackups.fulfilled, (s, a: PayloadAction<IBackupItem[]>) => {
                s.list = a.payload; s.isLoading = false;
            })
            .addCase(fetchGetBackups.rejected, (s) => { s.isLoading = false; })
            .addCase(fetchRunBackup.pending, (s) => { s.isLoading = true; })
            .addCase(fetchRunBackup.fulfilled, (s, a: PayloadAction<IBackupItem[]>) => {
                s.list = a.payload; s.isLoading = false;
            })
            .addCase(fetchRunBackup.rejected, (s) => { s.isLoading = false; })
            .addCase(fetchRestoreBackup.pending, (s) => { s.isRestoring = true; })
            .addCase(fetchRestoreBackup.fulfilled, (s) => { s.isRestoring = false; })
            .addCase(fetchRestoreBackup.rejected, (s) => { s.isRestoring = false; });
    },
});

export default BackupSlice.reducer;